import { render, staticRenderFns } from "./simpleTable.vue?vue&type=template&id=ca904254&"
import script from "./simpleTable.vue?vue&type=script&lang=js&"
export * from "./simpleTable.vue?vue&type=script&lang=js&"
import style0 from "./simpleTable.vue?vue&type=style&index=0&id=ca904254&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports